<template>
    <el-dialog :title="Object.keys(info).length === 0 ? '新增商品' : '修改商品'" :visible.sync="dialogVisible" width="700px" :before-close="handleClose">
        <el-form ref="form" size="small" :rules="rules" :model="form" label-width="130px">
            <el-form-item label="商品类型" prop="schema_name">
                <el-select v-model="form.schema_name" placeholder="请选择商品类型" :disabled="Object.keys(info).length > 0" style="width: 100%">
                    <el-option v-for="item of schema_name_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="平台卡类型" prop="type" v-if="form.schema_name === 'platform_times_card'">
                <el-select v-model="form.type" placeholder="请选择平台卡类型" :disabled="Object.keys(info).length > 0" style="width: 100%">
                    <el-option v-for="item of platform_times_card_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="商品名字" prop="name">
                <el-input v-model="form.name" placeholder="请输入商品名字"></el-input>
            </el-form-item>

            <el-form-item label="商品简述" prop="description">
                <el-input type="textarea" v-model="form.description" placeholder="请输入商品简述"></el-input>
            </el-form-item>

            <el-form-item label="商品banner">
                <div v-if="imageUrl">
                    <img class="el-upload-list__item-thumbnail" :src="imageUrl" alt="" />
                    <span class="el-upload-list__item-actions">
                        <span @click="handleUploadRemove">
                            <i class="el-icon-delete"></i>
                        </span>
                    </span>
                </div>
                <el-upload action="" list-type="picture-card" :auto-upload="false" :on-change="handleUploadChange" v-else>
                    <i slot="default" class="el-icon-plus"></i>
                </el-upload>
                <p v-if="!imageUrl" style="color: red">*banner 尺寸比例(1:0.56)</p>
            </el-form-item>

            <el-form-item label="平台推荐码" prop="codes" v-if="form.schema_name === 'redeem_code'">
                <el-input type="textarea" v-model.trim="form.codes" placeholder="请输入第三方平台推荐码,多个用,分隔开"></el-input>
                <p v-if="Object.keys(info).length > 0" style="color: red; line-height: 1.3; margin-top: 3px">
                    *修改后的推荐码，对已经够买的无效,
                    <br />
                    例如：现已购买2次,则前两位推荐码的修改不会对已购买过的生效
                </p>
            </el-form-item>

            <el-form-item label="资料包下载地址" prop="download_href" v-if="form.schema_name === 'information_package_download'">
                <el-input type="textarea" v-model.trim="form.download_href" placeholder="请输入资料包下载地址"></el-input>
            </el-form-item>

            <el-form-item label="已经购买次数" v-if="Object.keys(info).length > 0">
                <el-input v-model.trim="info.minted" disabled></el-input>
            </el-form-item>

            <el-form-item label="最大供应量" prop="max" v-if="form.schema_name !== 'redeem_code'">
                <el-input v-model.trim="form.max" placeholder="请输入最大供应数量" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </el-form-item>

            <el-form-item label="购买消耗积分" prop="points">
                <el-input v-model.trim="form.points" placeholder="请输入购买消耗积分" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </el-form-item>

            <el-form-item label="获得免费次数" prop="available_times" v-if="form.schema_name === 'platform_times_card'">
                <el-input v-model.trim="form.available_times" placeholder="请输入获得免费次数" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </el-form-item>

            <el-form-item label="活动状态">
                <el-switch v-model="form.status" active-color="#13ce66" active-text="打开" inactive-text="暂停" :active-value="activeValue" :inactive-value="inactiveValue"></el-switch>
            </el-form-item>

            <el-form-item class="add_active_footer">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" v-if="Object.keys(info).length === 0" :loading="loading" @click="onSubmit">创建</el-button>
                <el-button type="primary" v-else :loading="loading" @click="onUpdata">更新</el-button>
            </el-form-item>
            <p v-if="Object.keys(info).length > 0" style="color: red; text-align: center">*本次修改不对已经购买过的用户订单生效</p>
        </el-form>
    </el-dialog>
</template>

<script>
import serverApi from '../../../server/index';
export default {
    props: ['dialogVisible', 'schema_name_list', 'info', 'platform_times_card_list'],
    data() {
        return {
            imageUrl: '',
            disabled: false,
            file: null,

            form: {
                schema_name: '',
                type: '',
                name: '',

                description: '',
                codes: '',
                download_href: '',
                max: '',
                points: '',
                available_times: '',
                banner: '',
                status: 'open',
            },
            loading: false,
            rules: {
                schema_name: [{ required: true, message: '请选择商品类型', trigger: 'change' }],
                type: [{ required: true, message: '请选择平台卡类型', trigger: 'change' }],
                name: [{ required: true, message: '请输入商品名字', trigger: 'blur' }],
                description: [{ required: true, message: '请输入商品简述', trigger: 'blur' }],
                codes: [{ required: true, message: '请输入第三方平台推荐码', trigger: 'blur' }],
                max: [{ required: true, message: '请输入最大供应数量', trigger: 'blur' }],
                points: [{ required: true, message: '请输入购买消耗积分', trigger: 'blur' }],
                download_href: [{ required: true, message: '请输入资料包下载地址', trigger: 'blur' }],
                available_times: [{ required: true, message: '请输入获得免费次数', trigger: 'blur' }],
            },

            activeValue: 'open',
            inactiveValue: 'close',
        };
    },
    methods: {
        onSubmit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    try {
                        console.log('values', this.form);
                        let params = {};
                        if (!this.file) {
                            throw new Error('缺少商品banner');
                        }
                        if (this.form.schema_name === 'redeem_code') {
                            params = {
                                name: this.form.name,
                                schema_name: 'redeem_code',
                                description: this.form.description,
                                code_list: this.form.codes.replace(/，/g, ',').split(','),
                                points: Number(this.form.points),
                                max: Number(this.form.codes.replace(/，/g, ',').split(',').length),
                                // minted: this.info.minted,
                                // is_over: this.info.is_over,
                                status: this.form.status,
                            };
                            if (params.code_list.length === 0) {
                                throw new Error('缺少平台推荐码配置');
                            }
                        } else if (this.form.schema_name === 'information_package_download') {
                            params = {
                                name: this.form.name,
                                schema_name: 'information_package_download',
                                description: this.form.description,
                                download_href: this.form.download_href,
                                points: Number(this.form.points),
                                max: Number(this.form.max),
                                status: this.form.status,
                            };
                            if (params.max === 0) {
                                throw new Error('最大供应量 配置 要大于0');
                            }
                            if (params.points === 0) {
                                throw new Error('消耗积分 配置 要大于0');
                            }
                        } else if (this.form.schema_name === 'platform_times_card') {
                            params = {
                                name: this.form.name,
                                type: this.form.type,
                                schema_name: 'platform_times_card',
                                description: this.form.description,
                                points: Number(this.form.points),
                                max: Number(this.form.max),
                                available_times: Number(this.form.available_times),
                                status: this.form.status,
                            };
                        }

                        let _form = new FormData();
                        for (let key in params) {
                            console.log('ele', key);
                            _form.append(key, params[key]);
                        }
                        if (this.file) {
                            _form.append('banner', this.file ? this.file.raw : this.imageUrl);
                        }

                        this.loading = true;
                        console.log('params', params);

                        serverApi
                            .addVoucher(_form)
                            .then(res => {
                                if (res.data.code === 0) {
                                    this.$message({
                                        message: '添加成功',
                                        type: 'success',
                                    });
                                    this.$emit('closeModal', true);
                                } else {
                                    this.$message({
                                        message: res.data.msg || res.data.error,
                                        type: 'error',
                                    });
                                }
                            })
                            .catch(e => {
                                this.$message({
                                    message: e.data.error || e.data.msg,
                                    type: 'error',
                                });
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    } catch (e) {
                        this.$message({
                            message: e.message,
                            type: 'error',
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        onUpdata() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    try {
                        console.log('values', this.form);
                        let params = {};
                        if (this.form.schema_name === 'redeem_code') {
                            params = {
                                name: this.form.name,
                                schema_name: 'redeem_code',
                                description: this.form.description,
                                code_list: this.form.codes.replace(/，/g, ',').split(','),
                                points: Number(this.form.points),
                                max: Number(this.form.codes.replace(/，/g, ',').split(',').length),
                                // minted: this.info.minted,
                                // is_over: this.info.is_over,
                                status: this.form.status,
                            };
                            if (params.code_list.length === 0) {
                                throw new Error('缺少平台推荐码配置');
                            }
                            if (params.code_list.length < this.info.minted) {
                                throw new Error('平台推荐码数量不能小于当前已经购买的数量');
                            }
                        } else if (this.form.schema_name === 'information_package_download') {
                            params = {
                                name: this.form.name,
                                schema_name: 'information_package_download',
                                description: this.form.description,
                                download_href: this.form.download_href,
                                points: Number(this.form.points),
                                max: Number(this.form.max),
                                // minted: this.info.minted,
                                // is_over: this.info.is_over,
                                status: this.form.status,
                            };
                            if (params.max === 0) {
                                throw new Error('最大供应量 配置 要大于0');
                            }
                            if (params.points === 0) {
                                throw new Error('消耗积分 配置 要大于0');
                            }
                            if (params.max < this.info.minted) {
                                throw new Error('最大供应数量不能小于当前已经购买的数量');
                            }
                        } else if (this.form.schema_name === 'platform_times_card') {
                            params = {
                                name: this.form.name,
                                schema_name: 'platform_times_card',
                                description: this.form.description,
                                points: Number(this.form.points),
                                max: Number(this.form.max),
                                // minted: this.info.minted,
                                available_times: Number(this.form.available_times),
                                // is_over: this.info.is_over,
                                status: this.form.status,
                            };
                            if (params.max < this.info.minted) {
                                throw new Error('最大供应数量不能小于当前已经购买的数量');
                            }
                        }
                        params.id = this.info.id;

                        let _form = new FormData();
                        for (let key in params) {
                            console.log('ele', key);
                            _form.append(key, params[key]);
                        }

                        console.log('file--->', this.file);
                        if (this.file) {
                            _form.append('banner', this.file ? this.file.raw : this.imageUrl);
                        }

                        console.log('params', params);
                        console.log('_form', _form);
                        console.log('file', this.file);

                        this.loading = true;
                        serverApi
                            .updataVoucher(_form)
                            .then(res => {
                                if (res.data.code === 0) {
                                    this.$message({
                                        message: '修改成功',
                                        type: 'success',
                                    });
                                    this.$emit('closeModal', true);
                                } else {
                                    this.$message({
                                        message: res.data.msg || res.data.error,
                                        type: 'error',
                                    });
                                }
                            })
                            .catch(e => {
                                this.$message({
                                    message: e.data.error || e.data.msg,
                                    type: 'error',
                                });
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    } catch (e) {
                        this.$message({
                            message: e.message,
                            type: 'error',
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleClose() {
            this.$emit('closeModal', false);
        },
        handleUploadChange(file) {
            console.log('file--->', file);
            this.file = file;
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        handleUploadRemove() {
            this.file = null;
            this.imageUrl = '';
        },
    },
    created() {
        console.log('info', this.info);

        if (Object.keys(this.info).length > 1) {
            const { schema_name, name, description, banner, code_list, points, max, download_href, available_times, type, status } = this.info;
            if (banner) this.imageUrl = `https://asset.promptport.ai/files${banner}`;
            this.form = {
                schema_name,
                name,

                description,
                banner,
                codes: schema_name === 'redeem_code' ? code_list.join(',') : '',
                download_href: schema_name === 'information_package_download' ? download_href : '',
                max: schema_name === 'redeem_code' ? '' : max,
                points,
                available_times: schema_name === 'platform_times_card' ? available_times : '',
                type: schema_name === 'platform_times_card' ? type : '',
                status,
            };
        }
    },
};
</script>

<style lang="scss">
.el-upload-list__item-thumbnail {
    /* width: 100%;
    height: auto; */
    width: 264px;
    height: 149px;
    display: block;
    border-radius: 6px;
    max-height: 250px;
}
.el-upload-list__item-actions {
    display: flex;
    /* width: 100%; */
    width: 264px;
    height: 100%;
    max-height: 250px;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 20px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 0;
    transition: opacity 0.3s;
    &:hover {
        opacity: 1;
    }

    span {
        cursor: pointer;
    }
}
.add_active_footer {
    margin-top: 30px;
    button {
        width: 200px;
        margin-right: 30px;
        height: 35px;
        &:last-child {
            margin-right: 0;
        }
    }
}
</style>
